import { createFileRoute } from '@tanstack/react-router';
import { AccountScreen } from '@/components/account/AccountScreen';

/** ADR-099 / ADR-100: an account by email, the 18+ declaration, credits and the shop. */
export const Route = createFileRoute('/_site/account')({
  head: () => ({
    meta: [{ title: 'Account — Everwake' }, { name: 'robots', content: 'noindex' }],
  }),
  component: AccountScreen,
});
